define(
    'NVT.NewContactRegistration.NewContactCreation.View',
    [
        'nvt_new_contact_creation.tpl',
        'NVT.NewContactRegistration.NewContactRegistration.SS2Model',
        'Backbone',
        'jQuery',
        'Utils',
        'GlobalViews.Message.View',
        'underscore',
        'Account.Register.Model',
    ],
    function (
        tpl,
        NewContactCreationSS2Model,
        Backbone,
        jQuery,
        Utils,
        GlobalViewsMessageView,
        _,
        AccountRegisterModel,
    ) {
        'use strict';
        return Backbone.View.extend({

            template: tpl,

            events: {
                'change #corporateindividual': 'onSelectCorporateType',
                'change #addlocalforeigner_category': 'onSelectLocalForeigner',
                'keyup #mysearchCompany': 'debouncedSearch',
            },

            initialize: function (options) {
                this.options = options || {};
                this.companyModel = new NewContactCreationSS2Model();
                this.model = new AccountRegisterModel();
                _.extend(AccountRegisterModel.prototype, Backbone.Validation.mixin);
                this.debouncedSearch = _.debounce(this.searchAndGetListCompany.bind(this), 1000);
                this.state = new Backbone.Model({
                    corporateindividual: '1',
                    selectedlocalforeigner_category: '1',
                    invalidcomment: '',
                    assignuen: '',
                    companyList: []
                });

                this.listenTo(this.state, 'change', this.render);
                this.bindBeforeRegister();
            },

            nullCheck: function nullCheck(value) {
                var self = this;
                if (value != null && value != '' && value != undefined)
                    return true;
                else
                    return false;
            },
            // showFieldError: function (field, message) {
            //     jQuery('.global-views-message-error').remove();
            //     var messageView = new GlobalViewsMessageView
            //         ({
            //             message: message,
            //             type: 'error'
            //             , closable: false
            //         });
            //     if (typeof field !== 'undefined') {
            //         self.$('[data-input="' + field + '"]').append(messageView.render().$el);
            //     }
            //     else {
            //         self.$('form').empty().html(messageView.render().$el);
            //     }
            // },

            showMessage: function (message, type, field) {
                var self = this;
                jQuery('.global-views-message-error').remove();
                var messageView = new GlobalViewsMessageView
                    ({
                        message: message
                        , type: type
                        , closable: true
                    });
                if (typeof field !== 'undefined') {
                    self.$('[data-input="' + field + '"]').append(messageView.render().$el);
                }
                else {
                    self.$('form').empty().html(messageView.render().$el);
                }
            },

            clearFieldError: function (field) {
                this.$('[data-input="' + field + '"]').empty();
            },

            forceRebind: function () {
                if (this._modelBindings && Backbone.FormView && Backbone.FormView.add) {
                    Backbone.FormView.add(this);
                }
            },

            setState: function (obj) {
                if (_.isObject(obj)) {
                    this.state.set(obj);
                } else if (arguments.length === 2) {
                    this.state.set(arguments[0], arguments[1]);
                }
            },

            onSelectCorporateType: function (e) {
                const val = jQuery(e.target).val();
                this.setState({
                    corporateindividual: val,
                    invalidcomment: '',
                    companyList: [],
                    assignuen: ''
                });

                var defaultView = this.options.LoginRegisterPage.application.getLayout().currentView;
                if (defaultView && defaultView.$) {
                    defaultView.$('input[name="company"]').val('');
                    defaultView.$('input[name="uen"]').val('');
                    jQuery("input[name='company']").prop('readonly', false);
                }
            },

            onSelectLocalForeigner: function (e) {
                this.setState({
                    selectedlocalforeigner_category: jQuery(e.target).val()
                });
            },

            searchAndGetListCompany: function (e) {
                e.preventDefault();
                jQuery("input[name='company']").removeAttr("disabled");
                var keyword = jQuery('#mysearchCompany').val();
                var trimmed = keyword ? keyword.trim() : '';
                var self = this;

                if (!trimmed) {
                    self.setState({
                        invalidcomment: '',
                        companyList: [],
                        assignuen: ''
                    });

                    var defaultView = self.options.LoginRegisterPage.application.getLayout().currentView;
                    if (defaultView && defaultView.$) {
                        defaultView.$('input[name="company"]').val('');
                        defaultView.$('input[name="uen"]').val('');
                        jQuery("input[name='company']").prop('readonly', false);
                    }
                    return;
                }

                this.companyModel.fetch({
                    data: {
                        getsearchkeyword: trimmed,
                        getmethod: 'companyListSearching'
                    }
                }).done(function (res) {
                    if (!Array.isArray(res) || res.length === 0) {
                        self.setState({
                            invalidcomment: Utils.translate(
                                "We are unable to find your organisation in our records. Please complete the details below to create an account with us."
                            ),
                            companyList: [],
                            assignuen: trimmed
                        });
                        var defaultView = self.options.LoginRegisterPage.application.getLayout().currentView;
                        if (defaultView && defaultView.$) {
                            defaultView.$('input[name="company"]').val('');
                            defaultView.$('input[name="uen"]').val('');
                            jQuery("input[name='company']").prop('readonly', false);
                        }
                        return;
                    }

                    var company = res[0];
                    self.setState({
                        companyList: res,
                        assignuen: company.uenno || '',
                        invalidcomment: ''
                    });

                    var defaultView = self.options.LoginRegisterPage.application.getLayout().currentView;
                    if (defaultView && defaultView.$) {
                        defaultView.$('input[name="company"]').val(company.name);
                        defaultView.$('input[name="uen"]').val(company.internalid);
                        jQuery("input[name='company']").prop('readonly', true);
                    }
                }).fail(function () {
                    self.setState({
                        invalidcomment: Utils.translate(
                            "We are unable to find your organisation in our records. Please complete the details below to create an account with us."
                        ),
                        companyList: [],
                        assignuen: ''
                    });

                    var defaultView = self.options.LoginRegisterPage.application.getLayout().currentView;
                    if (defaultView && defaultView.$) {
                        defaultView.$('input[name="company"]').val('');
                        defaultView.$('input[name="uen"]').val('');
                        jQuery("input[name='company']").prop('readonly', false);
                    }
                });
            },

            bindBeforeRegister: function () {
                var self = this;

                if (!this.options?.LoginRegisterPage?.on) return;

                this.options.LoginRegisterPage.on('beforeRegister', function (form) {
                    self.clearErrors();
                    self.fieldErrors = {};
                    self.allErrors = [];

                    if (self.state.get('corporateindividual') === '1' && form.searchCompany.trim() === '') {
                        jQuery("input[name='searchCompany']").focus();
                        self.showMessage("UEN or Registration number is required.", 'error', 'mysearchCompany');
                        return jQuery.Deferred().reject();
                    }
                    else if (self.state.get('corporateindividual') === '1' && !self.nullCheck(form.company.trim())) {
                        jQuery("input[name='company']").focus();
                        self.showMessage("Organization Name is required", 'error', 'company');
                        jQuery("input[name='company']").prop('readonly', false);
                        return jQuery.Deferred().reject();
                    }
                    else if (self.state.get('corporateindividual') === '1' && self.state.get('companyList').length > 0) {

                        if ((form.searchCompany.trim() === '') || (!self.nullCheck(form.uen))) {
                            jQuery("input[name='searchCompany']").focus();
                            self.showMessage("UEN or Registration number is required.", 'error', 'mysearchCompany');
                            return jQuery.Deferred().reject();
                        }

                        self.model.set(form);
                        var errors = self.model.validate(form);
                        if (errors) {
                            self.fieldErrors = errors;
                            self.allErrors = _.values(errors);
                            _.each(errors, function (error, field) {
                                //self.showFieldError(field, error);
                                jQuery("[name=" + field + "]").focus();
                            });

                            return jQuery.Deferred().reject();
                        }

                        return self.submitContactCreation(form);
                    }
                    return jQuery.Deferred().resolve();
                });
            },

            submitContactCreation: function (formFields) {
                var self = this;
                return this.companyModel.fetch({
                    data: {
                        'getmethod': 'getcontactbycompany',
                        'getfirstname': formFields.firstname,
                        'getlastname': formFields.lastname,
                        'getuenid': formFields.uen,
                        'getuennumber': formFields.searchCompany.trim(),
                        'getcompany': formFields.company,
                        'getemail': formFields.email.trim(),
                        'getpassword': formFields.password,
                        'getpassword2': formFields.password2,
                        'getjobtitle': formFields.jobtitle,
                        'getphone': formFields.phone
                    }
                }).done(function (res) {
                    if (res.isFindExitingEmailUpercase) {
                        self.showError(Utils.translate('Email should be case-insensitive in existing account.'));
                        return jQuery.Deferred().reject();
                    }
                    else if (res.error.message === "Passwords don\'t match.\n" || res.error.message === "Passwords don\\'t match.\\n") {
                        self.showError(Utils.translate('Passwords does not match. You have tried to register an account with us, but an existing account already exists with the email ' + jQuery("input[name='email']").val() + '. Please click <a data-action="forgot-password" href="/forgot-password" class="checkoutwarning">to change your password</a> for this account if the original password does not allow you to login, or enter a different email address to create a new account.'));
                        return jQuery.Deferred().reject();
                    }
                    else if (res.error) {
                        self.showError(res.error.message);
                        return jQuery.Deferred().reject();
                    }
                    else {
                        jQuery.Deferred().resolve();
                    }
                }).fail(function () {
                    self.showError(
                        Utils.translate(
                            'You have tried to register an account with this email. Please click <a data-action="forgot-password" href="/forgot-password" class="checkoutwarning">to reset your password</a>.'
                        )
                    );
                    return jQuery.Deferred().reject();
                });
            },

            clearErrors: function () {
                this.$('[data-type="alert-placeholder"]').empty();
                this.$('[data-type="alert-placeholder-custome-error"]').empty();
                jQuery('.global-views-message-error').remove();
            },

            showError: function (msg) {
                const view = new GlobalViewsMessageView({
                    message: msg,
                    type: 'error',
                    closable: true
                });

                const htmldata = view.render().$el.html();
                jQuery('[data-type="alert-placeholder"]').html(htmldata);
                this.$('[data-type="alert-placeholder-custome-error"]').html(htmldata);
            },

            getContext: function () {
                const s = this.state;
                return {
                    isCorporate: s.get('corporateindividual') === '1',
                    selectedlocalforeigner_category: s.get('selectedlocalforeigner_category') === '2',
                    assignuen: s.get('assignuen'),
                    invalidcomment: s.get('invalidcomment'),
                    NewContactRegistrationdescription:
                        s.get('corporateindividual') === '2'
                            ? SC.CONFIGURATION.NewContactRegistration.customindividual
                            : SC.CONFIGURATION.NewContactRegistration.customcorporate
                };
            }
        });

    }
);
